import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import firebase from "../config/firebase";
import { useDispatch, useSelector } from "react-redux";
import { addManagersRequests } from "store/actions/managerAction";
import { fetchManagersRequests } from "store/actions/managerAction";
import moment from "moment";
import Header from "components/Headers/Header";
import { deleteRequest } from "store/actions/managerAction";
import { editRequest } from "store/actions/managerAction";
import ReuseableTable from "components/Tables/ReuseableTable";

const ManagerHelper = () => {
  let dispatch = useDispatch();
  const [loader, setLoader] = useState({
    data: false,
    btn: false,
    loaderMore: false,
  });
  const [data, setData] = useState({
    details: "",
  });
  const [requestModal, setRequestModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [collectionId, setCollectionId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  let { uid, user } = useSelector((state) => state.auth);
  let { requests, lastDocument, hasMore } = useSelector(
    (state) => state.manager
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const deleteModalToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const createRequestModal = () => {
    setRequestModal(!requestModal);
  };
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      fetchManagersRequests(uid, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  const loadMore = () => {
    setLoader((prev) => ({
      ...prev,
      loaderMore: true,
    }));
    dispatch(
      fetchManagersRequests(uid, lastDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loaderMore: false,
        }));
      })
    );
  };

  const submitData = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    if (isEdit) {
      let requestData = {
        requestDetail: data.details,
      };
      dispatch(
        editRequest(collectionId, requestData, (res) => {
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
          if (res == "success") {
            createRequestModal();
            setIsEdit(false);
            setData((prev) => ({
              ...prev,
              details: "",
            }));
          }
        })
      );
    } else {
      let requestData = {
        requestDetail: data.details,
        requestedId: uid,
        created_at: firebase.firestore.Timestamp.now(),
        type: "Athlete",
      };
      dispatch(
        addManagersRequests(requestData, (res) => {
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
          if (res == "success") {
            createRequestModal();
            setData((prev) => ({
              ...prev,
              details: "",
            }));
          }
        })
      );
    }
  };

  const TABLE_DATA = {
    columns: ["Request Detail", "Created At"],
    keyMap: {
      "Request Detail": "requestDetail",
      "Created At": "createdAt",
    },
    data:
      requests.length > 0 ? (
        requests?.map((item, index) => {
          return {
            id: item.id,
            requestDetail: (
              <span
                className="d-inline-block text-wrap w-100"
                style={{ maxWidth: "400px" }}
              >
                {item.requestDetail}
              </span>
            ),
            createdAt: moment
              .unix(item.created_at.seconds)
              .format("DD MMM YYYY"),
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
    renderActions: (row, index) => {
      return (
        <>
          {" "}
          <div className="d-flex flex-lg-row flex-column gap-2 align-items-center">
            <Button
              color="primary"
              size="sm"
              className="mb-2 mb-lg-0"
              onClick={() => {
                setCollectionId(row.id);
                setIsEdit(true);
                createRequestModal();
                setData((prev) => ({
                  ...prev,
                  details: row.requestDetail.props.children,
                }));
              }}
            >
              Edit
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={() => {
                deleteModalToggle();
                setCollectionId(row.id);
              }}
            >
              Delete
            </Button>
          </div>
        </>
      );
    },
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />

      <Container className="" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h1
                  className="mb-0"
                  style={{ fontSize: isSmallScreen ? "13px" : "24px" }}
                >
                  Seeking Manager
                </h1>
                <div className="d-flex  justify-content-center align-items-center">
                  <Button
                    color="primary"
                    onClick={() => {
                      setIsEdit(false);
                      createRequestModal();
                      setData((prev) => ({
                        ...prev,
                        details: "",
                      }));
                    }}
                  >
                    Create Request
                  </Button>
                </div>
              </CardHeader>
              {loader.data ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <ReuseableTable {...TABLE_DATA} />
                </>
              )}
              {requests.length > 4 && hasMore && (
                <div className="text-center py-4">
                  <Button
                    color="primary"
                    onClick={loadMore}
                    disabled={!hasMore || loader.loaderMore}
                  >
                    {loader.loaderMore ? <Spinner size="sm" /> : "Load More"}
                  </Button>
                </div>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={requestModal} toggle={createRequestModal} size="md">
        <ModalBody>
          <Form onSubmit={submitData}>
            <Container>
              <h1 className="text-center mb-4">Want Manager to Teach You </h1>
              <FormGroup>
                <Label for="detail">Request Details</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="detail"
                    placeholder="Add Request Details"
                    type="textarea"
                    value={data.details}
                    onChange={handleChange}
                    name="details"
                    required
                  />
                </InputGroup>
              </FormGroup>
            </Container>
            <div className="text-right mt-4">
              <Button color="danger" onClick={createRequestModal}>
                Cancel
              </Button>
              <Button color="primary" type="submit">
                {loader.btn ? (
                  <Spinner size="sm" />
                ) : isEdit ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={deleteModal} centered toggle={deleteModalToggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to delete Request.
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={deleteModalToggle}>
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={() => {
                setLoader((prev) => ({
                  ...prev,
                  btn: true,
                }));
                dispatch(
                  deleteRequest(collectionId, () => {
                    deleteModalToggle();
                    setLoader((prev) => ({
                      ...prev,
                      btn: false,
                    }));
                  })
                );
              }}
            >
              {loader.btn ? <Spinner size="sm" /> : "Delete"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ManagerHelper;
